import React from "react"

import "./styles.css"
import defaultImage from "../../../../../../../Assets/img/noProductImg.png"
import { SimpleImg } from "react-simple-img"

export default function CardProduto(props) {
  return (
    <>
      {props.products.map((item, index) => {
        return (
          <div className="cardInfo">
            <div className={index === 0 ? "fristItem" : "itemCard"}>
              {index === 0 ? "" : index + 1}
            </div>
            <div className="image">
              <SimpleImg
                height={60}
                width={60}
                placeholder={false}
                src={item.images.length > 0 ? item.images[0].sm_url : defaultImage}
                Alt=""
              />
            </div>
            <div className="cardTitle">
              <div>{item.product_title}</div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
              }}
            >
              <div className="cardText3">{item.tracking_total}</div>
              <div className="cardText1">visitas</div>
            </div>
          </div>
        )
      })}
    </>
  )
}
